type TenantClaim = string | string[] | null | undefined;

export function hasTenant(tenant: TenantClaim, expected: string): boolean {
  if (Array.isArray(tenant)) return tenant.includes(expected);
  return tenant === expected;
}

export const LAST_TENANT_KEY = "sigil:lastTenant";
export const getLastTenantKey = (uid: string): string =>
  `${LAST_TENANT_KEY}:${uid}`;

export function saveLastTenant(uid: string, tenant: string) {
  try {
    localStorage.setItem(getLastTenantKey(uid), tenant);
  } catch {}
}

interface ResolvedTenant {
  selectedTenant: string | null;
  availableTenants: string[] | null;
}

export function resolveTenantFromClaims(
  tenantFromClaims: TenantClaim,
  uid?: string | null,
): ResolvedTenant {
  if (Array.isArray(tenantFromClaims)) {
    if (tenantFromClaims.length === 1) {
      return { selectedTenant: tenantFromClaims[0], availableTenants: null };
    }

    if (tenantFromClaims.length > 1) {
      if (uid) {
        const saved = localStorage.getItem(getLastTenantKey(uid));
        if (saved && tenantFromClaims.includes(saved)) {
          return { selectedTenant: saved, availableTenants: null };
        }
      }
      return { selectedTenant: null, availableTenants: tenantFromClaims };
    }
  }

  return {
    selectedTenant:
      typeof tenantFromClaims === "string" ? tenantFromClaims : null,
    availableTenants: null,
  };
}
